module.exports = __webpack_public_path__ + "img/payment.3c629000.svg";